import { useEffect, useState } from "react";
import { ShoppingCart, IndianRupee, Users, Package, Star, MessageSquare, AlertTriangle, Mail } from "lucide-react";
import api, { formatPrice } from "@/lib/api";

function Stat({ icon: Icon, label, value, accent }) {
    return (
        <div className="bg-white border border-gray-200 rounded-lg p-5">
            <div className="flex items-center justify-between">
                <span className="text-xs uppercase tracking-wider text-gray-500">{label}</span>
                <Icon className={`h-4 w-4 ${accent ? "text-gold" : "text-gray-400"}`} />
            </div>
            <p className="text-2xl font-semibold mt-2">{value}</p>
        </div>
    );
}

export default function AdminDashboard() {
    const [s, setS] = useState(null);
    useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setS(data)); }, []);
    if (!s) return <div className="grid md:grid-cols-4 gap-4">{Array.from({ length: 8 }).map((_, i) => <div key={i} className="skeleton h-28 rounded-lg" />)}</div>;

    return (
        <div>
            <h1 className="text-2xl font-semibold mb-6">Dashboard</h1>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                <Stat icon={IndianRupee} label="Total Revenue" value={formatPrice(s.revenue)} accent />
                <Stat icon={ShoppingCart} label="Total Orders" value={s.total_orders} />
                <Stat icon={Users} label="Customers" value={s.total_customers} />
                <Stat icon={Package} label="Products" value={s.total_products} />
                <Stat icon={ShoppingCart} label="Pending Orders" value={s.pending_orders} />
                <Stat icon={ShoppingCart} label="Processing" value={s.processing_orders} />
                <Stat icon={ShoppingCart} label="Shipped" value={s.shipped_orders} />
                <Stat icon={ShoppingCart} label="Delivered" value={s.delivered_orders} />
                <Stat icon={AlertTriangle} label="Low Stock" value={s.low_stock_products} accent />
                <Stat icon={Star} label="Pending Reviews" value={s.pending_reviews} accent />
                <Stat icon={MessageSquare} label="New Enquiries" value={s.pending_enquiries} accent />
                <Stat icon={Mail} label="Subscribers" value={s.newsletter_subscribers} />
            </div>
        </div>
    );
}
